import { render, staticRenderFns } from "./CardMakerView.vue?vue&type=template&id=24be287a&"
import script from "./CardMakerView.vue?vue&type=script&lang=ts&"
export * from "./CardMakerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports